import { renderText, textInline } from '../../utils'

// 例（target）：contentfulInformation.title
function CustomTemplateText({
  data: pageData,
  context: pageContext,
  // component props
  target = '',
  withBr = false,
}) {
  const text = textInline({
    data: {
      ...pageData,
      pageContext,
    },
    target,
  })
  if (text == null) {
    return null
  }

  return withBr ? renderText(text) : text
}

export { CustomTemplateText }
